import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {NgModule} from '@angular/core';
import {AppComponent} from './app.component';
import {routing} from './app.routing';
import {LayoutModule} from './layout/layout.module';
import {ConfigurationModule} from './configuration/configuration.module';
import {ToastModule} from 'ng2-toastr/ng2-toastr';
import {SlimScroll} from 'angular-io-slimscroll';
import {TranslateModule} from 'ng2-translate';
import {OpdModule} from './opd/opd.module';
import {PagesModule} from './pages/pages.module';
import {OperationTheaterModule} from './operation-theater/operation-theater.module';
import {IpdModule} from './ipd/ipd.module';
import {BillingModule} from './billing/billing.module';
import {InvestigationModule} from './investigation/investigation.module';
import {NursingStationModule} from './nursingstation/nursingstation.module';
import {PatientChartModule} from './patient-chart/patient-chart.module';
import {TokenListModule} from './token-list/token-list.module';
import {InventoryModule} from './inventory/inventory.module';
import {CaseReportModule} from './case-report/case-report.module';
import {MisModule} from './mis/mis.module';
import {HttpClientModule} from '@angular/common/http';
import {CasepaperModule} from './casepaper/casepaper.module';
import {IpdPatientCasePaperModule} from './ipd-patient-case-paper/ipd-patient-case-paper.module';
import {SharedTranslationModule} from './shared/change-language/shared-translation.module';
import {EmergencyModule} from './emergency/emergency.module';
import {ExcelService} from './exportexcel/excel.service';
import {OtSummaryModule} from './ot-summary/ot-summary.module';
import {MourturyModule} from './mourtury/mourtury.module';
import {DialogModule, DropdownModule} from 'primeng/primeng';
import {DocumentManagementSystemComponent} from './document-management-system/document-management-system.component';
import {DocumentManagementSystemModule} from './document-management-system/document-management-system.module';
import {CssdComponent} from './cssd/cssd.component';
import {CssdModule} from './cssd/cssd.module';
import {BloodTransfusionModule} from './blood-transfusion/blood-transfusion.module';
import {RequisitionListModule} from './blood-transfusion/requisition-list/requisition-list.module';
import {DonarListModule} from './blood-transfusion/donar-list/donar-list.module';
import {FormsModule} from '@angular/forms';
import {EmrsidebarModule} from './emrsidebar/emrsidebar.module';
import {AccountingModule} from './accounting/accounting.module';
import {TokenDisplayModule} from './token-display/token-display.module';
import {RequisitionListService} from './blood-transfusion/requisition-list/requisition-list.service';
import { InterfaceConfigModule } from './configuration/interface-config/interface-config.module';
// import { PageComponent } from './page/page.component';


@NgModule({
    declarations: [
        AppComponent,
        SlimScroll,
        DocumentManagementSystemComponent,
        CssdComponent,

        // PageComponent,
        // NumberToWordsPipePipe,

    ],
    imports: [
        InterfaceConfigModule,
        BrowserModule, LayoutModule, BrowserAnimationsModule, routing, ConfigurationModule, ToastModule.forRoot(), TranslateModule.forRoot(),
        OpdModule,
        PagesModule,
        HttpClientModule,
        OperationTheaterModule,
        IpdModule,
        /* RadiologyModule,*/
        EmergencyModule,
        NursingStationModule,
        AccountingModule,
        BloodTransfusionModule,
        RequisitionListModule,
        BillingModule,
        SharedTranslationModule,
        InvestigationModule,
        PatientChartModule,
        DocumentManagementSystemModule,
        TokenListModule,
        InventoryModule,
        CaseReportModule,
        CssdModule,
        DonarListModule,
        CasepaperModule,
        DropdownModule,
        MisModule,
        OtSummaryModule,
        IpdPatientCasePaperModule,
        DialogModule,
        MourturyModule,
        FormsModule,
        EmrsidebarModule,
        TokenDisplayModule,

    ],
    providers: [ExcelService],
    bootstrap: [AppComponent],
    // exports: [NumberToWordsPipe]
})
export class AppModule {
}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/app.module.ts